var a = "kunden-konto-session-id", o = null, i = () => {
  try {
    return window.__DD_RUM__;
  } catch {
    return;
  }
}, l = () => typeof i()?.addError == "function", u = () => {
  try {
    return window.__DD_LOGS__;
  } catch {
    return;
  }
}, m = () => typeof u()?.info == "function", c = (r) => r instanceof Error ? r.message : String(r), v = (r) => r instanceof Error ? r : new Error(c(r)), p = () => typeof i()?.startOperation == "function", f = () => {
  for (const r of ["_dd_s_v2", "_dd_s"]) {
    const n = document.cookie.match(new RegExp(`(?:^|;\\s*)${r}=([^;]*)`));
    if (n) {
      const t = n[1].match(/(?:^|&)id=([^&]+)/);
      if (t && t[1] && t[1] !== "null") return t[1];
    }
  }
  return null;
}, _ = () => crypto.randomUUID?.() ?? "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (r) => {
  const n = Math.random() * 16 | 0;
  return (r === "x" ? n : n & 3 | 8).toString(16);
}), s = window, E = () => {
  const r = f();
  return r || (s[a] || (s[a] = _()), s[a]);
}, g = (r) => {
  o = r;
}, I = () => o, x = () => {
  const r = {}, n = f();
  return n && (r.sessionId = n), o && (r.correlationId = o), r;
}, S = (r, n, t = "warn") => {
  const e = u();
  if (e && typeof e[t] == "function")
    return e[t](c(r), {
      ...x(),
      ...n
    }), !0;
  const d = i();
  return typeof d?.addError == "function" ? (d.addError(v(r), {
    ...x(),
    ...n,
    suppressed: !0
  }), !0) : !1;
};
export {
  m as areLogsEnabled,
  p as areOperationsEnabled,
  x as buildOperationBaseContext,
  I as getCorrelationId,
  u as getLogsShim,
  i as getRumShim,
  E as getSessionId,
  l as isRumEnabled,
  S as logSuppressedError,
  _ as randomId,
  f as readSessionIdFromCookie,
  g as setCorrelationId,
  v as toError,
  c as toErrorMessage
};

//# sourceMappingURL=datadog.helper.js.map